define( function() {
	return ( /^margin/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/css/var/rmargin.js
 ** module id = 866
 ** module chunks = 2
 **/